import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./AIChat.css";
import ServiceFooter from "../../ServiceFooter";
import { IoGlobeOutline } from "react-icons/io5";
import { IoBulb } from "react-icons/io5";
import { FaMicrophone } from "react-icons/fa";
import { VscSend } from "react-icons/vsc";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

const AIChat = () => {
  const [isLastSlide, setIsLastSlide] = useState(false);
  const navigate = useNavigate("");

  const textsettings = {
    dots: false,
    speed: 800,
    autoplaySpeed: 2000,
    infinite: true, // Keep infinite looping
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    autoplay: true,
    verticalSwiping: true,
    beforeChange: function (currentSlide, nextSlide) {
      // Assuming there are 3 slides and index is zero-based
      if (nextSlide === 2) {
        // Next slide is the last one
        setIsLastSlide(true);
      } else {
        setIsLastSlide(false); // Reset on other slides
      }
    },
  };

  // service
  const [isPrevServiceDisabled, setIsPrevServiceDisabled] = useState(true);
  const [isNextServiceDisabled, setIsNextServiceDisabled] = useState(false);

  const handleServiceChange = (ServiceSwiper) => {
    setIsPrevServiceDisabled(ServiceSwiper.isBeginning);
    setIsNextServiceDisabled(ServiceSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>AI chatbot development company</title>

        <meta name="title" content="AI chatbot development company" />
        <meta
          name="description"
          content="Streamline your business with a premium AI chatbot development company. Talk to AI experts."
        />

        <meta property="og:title" content="AI chatbot development company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/ai-chatbot-development-company"
        />
      </Helmet>

      <main className="ai_chat_main">
        {/* hero */}
        <article className="ai_chat_hero ai_ch_mb_80">
          <div className="container">
            <div className="row ai_hero_row">
              <div className="col-lg-3">
                <div className="ai_hero_card_outer ai_hr_one">
                  <div className="ai_hero_card_inner">
                    <p className="ai_hero_content">
                      Give me a movie plot in 5 ridiculous words.
                    </p>
                    <div className="text-center">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="ai_hero_card_btn"
                      >
                        Give me answers{" "}
                        <span>
                          <img
                            src={require("../../../image/aichat/sparkle-black.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="ai_hero_card_outer ai_hr_two">
                  <div className="ai_hero_card_inner">
                    <p className="ai_hero_content">
                      AI chatbot with funny glowing questions in a sci-fi room.
                    </p>
                    <div className="text-center">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="ai_hero_card_btn"
                      >
                        Generate{" "}
                        <span>
                          <img
                            src={require("../../../image/aichat/sparkle-black.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="col-lg-3">
                <div className="ai_hero_card_outer ai_hr_three">
                  <div className="ai_hero_card_inner">
                    <p className="ai_hero_content">
                      What's the laziest invention ever imagined?
                    </p>
                    <div className="text-center">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="ai_hero_card_btn"
                      >
                        Give me answers{" "}
                        <span>
                          <img
                            src={require("../../../image/aichat/sparkle-black.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="col-lg-3">
                <div className="ai_hero_card_outer ai_hr_four">
                  <div className="ai_hero_card_inner">
                    <p className="ai_hero_content">
                      If a potato ran for president, what’s its campaign slogan?
                    </p>
                    <div className="text-center">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="ai_hero_card_btn"
                      >
                        Generate{" "}
                        <span>
                          <img
                            src={require("../../../image/aichat/sparkle-black.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ai_ch_hero_cnt">
              <h1 className="ai_ch_hero_title">
                {" "}
                <span className="ai_ch_span">AI Chatbot</span> development
                company
              </h1>
              <p className="ai_ch_hero_content">
                From consultation and strategy to development and support, our
                AI chatbot development company is your trusted partner for
                success in the AI-powered future.
              </p>

              <div className="ai_command_wrap">
                <div className="ai_cmd_top">
                  <img
                    src={require("../../../image/aichat/cmd-star.webp")}
                    alt="AI chatbot development company"
                  />

                  <Slider {...textsettings} className="ai_slick_wrap">
                    <div className={isLastSlide ? "fade-out" : ""}>
                      <p className="ai_cmd_content">
                        Tell me a weird fact that sounds fake but is actually
                        true. And turn it into a one-line joke.
                      </p>
                    </div>
                    <div className={isLastSlide ? "fade-out" : ""}>
                      <p className="ai_cmd_content">
                        Write a motivational quote that sounds deep, but was
                        clearly made up on the spot.
                      </p>
                    </div>
                    <div className={isLastSlide ? "fade-out" : ""}>
                      <p className="ai_cmd_content">
                        Imagine I’m hosting a dinner party for aliens. What 3
                        Earth foods should I serve to impress them?
                      </p>
                    </div>
                    <div className={isLastSlide ? "fade-out" : ""}>
                      <p className="ai_cmd_content">
                        If animals could talk for one hour, what would mine say?
                      </p>
                    </div>
                    <div className={isLastSlide ? "fade-out" : ""}>
                      <p className="ai_cmd_content">
                        Invent a new holiday that the world definitely doesn’t
                        need, but would secretly love to celebrate.
                      </p>
                    </div>
                  </Slider>
                </div>
                <div className="ai_cmd_bottom">
                  <div className="ai_cmd_bt_lft">
                    <div className="ai_plus_wrap">
                      <i className="fa-solid fa-plus"></i>
                    </div>
                    <div className="ai_search_wrap">
                      <span className="ai_search_icon">
                        <IoGlobeOutline />
                      </span>

                      <span className="ai_cmd_cnt">Search</span>
                    </div>
                    <div className="ai_search_wrap">
                      <span className="ai_search_icon">
                        <IoBulb />
                      </span>

                      <span className="ai_cmd_cnt">Reason</span>
                    </div>
                  </div>
                  <div className="ai_cmd_bt_rgt">
                    <div className="ai_plus_wrap">
                      <FaMicrophone />
                    </div>
                    <div
                      onClick={() => navigate("/contact-us")}
                      className="ai_send_wrap"
                    >
                      <VscSend />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ai_hero_round">
              <div className="ai_circle_one_outer">
                <div className="ai_circle_one">
                  <div className="ai_circle_two_outer">
                    <div className="ai_circle_two">
                      <div className="ai_circle_three_outer">
                        <div className="ai_circle_three"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* about aichat */}
        <article className="primary__landing-content-container ai_ch_mb_100">
          <div className="ai_ch_abt_outer">
            <div className="ai_chat_abt">
              <div className="row g-4">
                <div className="col-xl-3 col-lg-4">
                  <h3 className="ai_ch_subtitle">
                    <span className="ai_ch_span">AI Chatbot </span>
                    development
                  </h3>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="ai_ch_btn"
                  >
                    <span>
                      <img
                        src={require("../../../image/aichat/sparkle-black.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    Get Started Today
                  </button>
                </div>
                <div className="col-xl-9 col-lg-8">
                  <div className="az-about-content ai_abt_cnt">
                    <p>
                      <span>
                        businesses are rapidly turning to automation to enhance
                        customer experience, streamline operations, and reduce
                        costs. One of the most impactful innovations in this
                        journey is the AI chatbot. From small startups to large
                        enterprises, everyone is exploring how to build AI
                        chatbot systems that transform their business
                        communication. This is where an AI chatbot development
                        company steps in. If you're looking to automate
                        conversations, offer 24/7 support, or scale customer
                        engagement, hiring the right AI chatbot development
                        company can be a game-changer.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* about two */}
        <article className="primary__landing-content-container ai_ch_mb_100">
          <h3 className="ai_ch_subtitle text-center">
            What is an <span className="ai_ch_span">AI Chatbot?</span>
          </h3>
          <div className="text-center">
            <img
              // src={require("../../../image/aichat/about.webp")}
              src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289149/aboutAiChatBot_itdfbi.webp"
              alt="AI chatbot development company"
              className="ai_abt_img"
            />
          </div>
          <p className="ai_abt_two_cnt">
            An AI chatbot is a software application powered by artificial
            intelligence (AI), natural language processing (NLP), and machine
            learning (ML) to simulate human-like conversations. AI chatbots
            learn from data, and provide more intelligent responses to
            understand context,  unlike rule-based chatbots.
          </p>
          <div className="text-center mt-4">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="ai_ch_btn"
            >
              <span>
                <img
                  src={require("../../../image/aichat/sparkle-black.webp")}
                  alt="AI chatbot development company"
                />
              </span>
              Get Free Demo
            </button>
          </div>
        </article>

        {/* use cases */}
        <article className="ai_ch_use_cases ai_ch_mb_100">
          <h6 className="ai_ch_use_title">
            <span className="ai_ch_span">Common Use Cases </span>
            Of AI ChatBot Development
          </h6>

          <Marquee speed={40} className="ai_ch_marquee_outer">
            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>Customer support</p>
            </div>

            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>E-commerce recommendations</p>
            </div>
            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>Lead generation</p>
            </div>
            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>Appointment scheduling</p>
            </div>
            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>HR & internal support</p>
            </div>
            <div className="ai_ch_marquee_wrap">
              <span className="ai_marquee_list"></span>
              <p>Healthcare queries</p>
            </div>
          </Marquee>
        </article>

        <div className="ai_ch_grad_outer">
          {/* why partnering */}
          <article className="ai_ch_why ai_ch_mb_50">
            <div className="primary__landing-content-container">
              <div className="row g-4">
                <div className="col-lg-5">
                  <h3 className="ai_ch_subtitle">
                    Why{" "}
                    <span className="ai_ch_span">
                      Partnering with an AI Chatbot
                    </span>{" "}
                    Development Company Matters
                  </h3>
                </div>
                <div className="col-lg-7">
                  <p className="ai_ch_subcontent">
                    Although DIY tools are available, building a smart, scalable
                    chatbot that truly delivers results takes specialized
                    knowledge. A professional AI chatbot development company
                    develops advanced solutions to align perfectly with your
                    business objectives and user needs.
                  </p>
                </div>
              </div>
            </div>
          </article>

          {/* key benefits */}
          <article className="container-fluid container-md ai_ch_mb_100">
            <div className="ai_ch_abt_outer">
              <div className="ai_ch_key_ben">
                <h3 className="ai_ch_subtitle ai_ch_kb_title">
                  <span className="ai_ch_span">Key Benefits Of </span>
                  AI Chatbot Development Company
                </h3>

                <div className="row ai_ch_kb_row">
                  <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="ai_ch_kb_lft">
                      <div className="ai_kb_out kb_cd_one">
                        <div className="ai_kb_card ">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-one.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">24/7 availability</p>
                              <span className="ai_kb_content_two">
                                Never miss a customer inquiry.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ai_kb_out kb_cd_two">
                        <div className="ai_kb_card ">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-two.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">Cost savings</p>
                              <span className="ai_kb_content_two">
                                Reduce the large customer support service team
                                needs.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ai_kb_out kb_cd_three">
                        <div className="ai_kb_card">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-three.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">Speed</p>
                              <span className="ai_kb_content_two">
                                Instant responses to repetitive queries.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-4 col-sm-6 ai_kb_img_col">
                    <div>
                      <img
                        src={require("../../../image/aichat/kb-center.webp")}
                        alt="AI chatbot development company"
                        className="kb_center_img"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6">
                    {" "}
                    <div className="ai_ch_kb_lft">
                      <div className="ai_kb_out kb_cd_four">
                        <div className="ai_kb_card ">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-four.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">Personalization</p>
                              <span className="ai_kb_content_two">
                                AI learns user behavior and tailors
                                communication.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ai_kb_out kb_cd_five">
                        <div className="ai_kb_card ">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-five.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">Scalability</p>
                              <span className="ai_kb_content_two">
                                Handle thousands of users simultaneously.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ai_kb_out kb_cd_six">
                        <div className="ai_kb_card ">
                          <div className="ai_kb_card_inner">
                            <span className="ai_kb_img_wrap">
                              <img
                                src={require("../../../image/aichat/kb-img-six.webp")}
                                alt="AI chatbot development company"
                              />
                            </span>
                            <div>
                              <p className="ai_kb_content">Compliance</p>
                              <span className="ai_kb_content_two">
                                Stay compliant with the regulatory framework of
                                your region.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <div className="ai_ch_grad"></div>
        </div>

        {/* services */}
        <article className="primary__landing-content-container ai_ch_mb_100">
          <h3 className="ai_ch_subtitle ai_ser_title">
            Services Offered by{" "}
            <span className="ai_ch_span">a Leading AI Chatbot </span>{" "}
            Development Company
          </h3>
          <p className="ai_ch_subcontent ai_ser_content">
            A top tier AI chatbot development company provides a full suite of
            solutions that go beyond just coding. Let’s look at some core AI
            chatbot development services you should expect
          </p>

          <>
            <Swiper
              className="ai_ser_swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation]}
              navigation={{
                prevEl: ".cr_doc_prev",
                nextEl: ".cr_doc_nxt",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleServiceChange}
              onReachBeginning={() => setIsPrevServiceDisabled(true)}
              onReachEnd={() => setIsNextServiceDisabled(true)}
              onFromEdge={() => {
                setIsPrevServiceDisabled(false);
                setIsNextServiceDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="ai_ch_service_card_outer">
                  <div className="ai_ch_service_card_inner">
                    <div className="ai_ser_img_wrap">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289949/ser-img-oneNew_ipyyeo.webp"
                        alt="AI chatbot development company"
                      />
                    </div>

                    <div className="ai_ser_contents">
                      <h5 className="ai_ser_card_title">
                        AI Chatbot Consulting
                      </h5>
                      <p className="ai_ser_card_content">
                        Get expert advice on the right strategy, platform, and
                        tech stack for your bot.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ai_ch_service_card_outer">
                  <div className="ai_ch_service_card_inner">
                    <div className="ai_ser_img_wrap">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289949/ser-img-twoNew_ef5zcb.webp"
                        alt="AI chatbot development company"
                      />
                    </div>

                    <div className="ai_ser_contents">
                      <h5 className="ai_ser_card_title">
                        Custom Chatbot Development
                      </h5>
                      <p className="ai_ser_card_content">
                        Whether you're targeting Facebook Messenger, WhatsApp, a
                        website, or a mobile app, AI chatbot app development
                        services ensure a seamless build.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ai_ch_service_card_outer">
                  <div className="ai_ch_service_card_inner">
                    <div className="ai_ser_img_wrap">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289949/ser-img-threeNew_kdb1aq.webp"
                        alt="AI chatbot development company"
                      />
                    </div>

                    <div className="ai_ser_contents">
                      <h5 className="ai_ser_card_title">
                        NLP & ML Integration
                      </h5>
                      <p className="ai_ser_card_content">
                        Train your chatbot to understand language, intent, and
                        sentiment using cutting-edge NLP and ML models.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ai_ch_service_card_outer">
                  <div className="ai_ch_service_card_inner">
                    <div className="ai_ser_img_wrap">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289948/ser-img-fourNew_osmdrs.webp"
                        alt="AI chatbot development company"
                      />
                    </div>

                    <div className="ai_ser_contents">
                      <h5 className="ai_ser_card_title">
                        Omni-channel Deployment
                      </h5>
                      <p className="ai_ser_card_content">
                        Deploy your chatbot on cross platforms like Telegram,
                        Website, or even voice assistants like Alexa.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ai_ch_service_card_outer">
                  <div className="ai_ch_service_card_inner">
                    <div className="ai_ser_img_wrap">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777289947/ser-img-fiveNew_mjuyj2.webp"
                        alt="AI chatbot development company"
                      />
                    </div>

                    <div className="ai_ser_contents">
                      <h5 className="ai_ser_card_title">
                        Maintenance & Upgrades
                      </h5>
                      <p className="ai_ser_card_content">
                        Ensure your chatbot remains smart, secure, and aligned
                        with business changes.
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`cr_doc_prev ${
                  isPrevServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevServiceDisabled ? "#ffffff8f" : "#fff",
                  cursor: isPrevServiceDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`cr_doc_nxt ${
                  isNextServiceDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextServiceDisabled ? "#ffffff8f" : "#fff",
                  cursor: isNextServiceDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </>
        </article>

        {/* build */}
        <article className="ai_ch_build ai_ch_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="ai_ch_subtitle text-center">
              Build <span className="ai_ch_span"> AI Chatbot</span>
            </h3>
            <p className="ai_ch_subcontent ai_build_content">
              When you partner with an AI chatbot development company, here's
              what the typical development journey looks like
            </p>
            <div className="text-center mt-4 ai_build_btn_wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_ch_btn"
              >
                <span>
                  <img
                    src={require("../../../image/aichat/sparkle-black.webp")}
                    alt="AI chatbot development company"
                  />
                </span>
                Start Building
              </button>
            </div>

            <div className="row ai_build_row">
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_one ">
                <img
                  src={require("../../../image/aichat/build-img-one.webp")}
                  alt="AI chatbot development company"
                />
                <h5>Requirement Gathering</h5>
                <p>
                  The journey of creating an AI chatbot begins with
                  understanding your business goals, target audience, and use
                  cases.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_two ">
                <img
                  src={require("../../../image/aichat/build-img-two.webp")}
                  alt="AI chatbot development company"
                />
                <h5>Designing Conversation Flow</h5>
                <p>
                  UX plays a huge role in chatbot success. Developers design
                  intuitive, human-like conversation scripts.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_three">
                <img
                  src={require("../../../image/aichat/build-img-three.webp")}
                  alt="AI chatbot development company"
                />
                <h5>Selecting Tech Stack</h5>
                <p>
                  Choose the right platforms (Dialogflow, Microsoft Bot
                  Framework, Rasa, etc.) and programming languages (Python,
                  Node.js, etc.).
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_four ">
                <img
                  src={require("../../../image/aichat/build-img-four.webp")}
                  alt="AI chatbot development company"
                />
                <h5>NLP Model Training</h5>
                <p>
                  The AI chatbot development services team trains the model with
                  real conversations, FAQs, and intent examples.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_five ">
                <img
                  src={require("../../../image/aichat/build-img-five.webp")}
                  alt="AI chatbot development company"
                />
                <h5>Integration</h5>
                <p>
                  Chatbots are integrated into CRMs, ERPs, live chat tools,
                  websites, and mobile apps.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 ai_build_card ai_bu_six">
                <img
                  src={require("../../../image/aichat/build-img-six.webp")}
                  alt="AI chatbot development company"
                />
                <h5>Testing & Deployment</h5>
                <p>
                  Rigorous testing ensures the chatbot behaves accurately before
                  it's rolled out to users.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* development services */}
        <article className="container-fluid container-md ai_ch_mb_100">
          <h3 className="ai_ch_subtitle text-center">
            <span className="ai_ch_span">AI Chatbot App </span>
            Development Services
          </h3>
          <p className="ai_ch_subcontent ai_ch_dv_content">
            Businesses need chatbots on the go in the mobile-first world. That’s
            where AI chatbot app development services come in. From Android and
            iOS integration to hybrid mobile solutions, these services allow
            users to interact with your brand anytime, anywhere.
          </p>

          <div className="row ai_dv_row">
            <div className="col-12 text-center">
              <div className="ai_dv_card">
                <div className="ai_dv_img_wrap ai_dv_top">
                  <img
                    src={require("../../../image/aichat/dev_serNew.webp")}
                    alt="AI chatbot development company"
                    className="dev_ser_img"
                  />
                </div>
                <h6>App Based Chatbot Features</h6>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4 col-sm-6 col-6 text-center">
                <div className="ai_dv_card dv_cd_one">
                  <div className="ai_dv_img_wrap">
                    <img
                      src={require("../../../image/aichat/dv-img-oneNew.webp")}
                      alt="AI chatbot development company"
                      className="dev_ser_img"
                    />
                  </div>
                  <h6>Push notifications</h6>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-6 text-center">
                <div className="ai_dv_card dv_cd_two">
                  <div className="ai_dv_img_wrap">
                    <img
                      src={require("../../../image/aichat/dv-img-threeNew.webp")}
                      alt="AI chatbot development company"
                      className="dev_ser_img"
                    />
                  </div>
                  <h6>Voice-to-text integration</h6>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-6 text-center">
                <div className="ai_dv_card dv_cd_three">
                  <div className="ai_dv_img_wrap">
                    <img
                      src={require("../../../image/aichat/dv-img-fiveNew.webp")}
                      alt="AI chatbot development company"
                      className="dev_ser_img"
                    />
                  </div>
                  <h6>Offline mode</h6>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4 col-sm-6 col-6 text-center">
                <div className="ai_dv_card dv_cd_four">
                  <div className="ai_dv_img_wrap">
                    <img
                      src={require("../../../image/aichat/dv-img-twoNew.webp")}
                      alt="AI chatbot development company"
                      className="dev_ser_img"
                    />
                  </div>
                  <h6>Payment gateway support</h6>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-6 text-center">
                <div className="ai_dv_card dv_cd_five">
                  <div className="ai_dv_img_wrap">
                    <img
                      src={require("../../../image/aichat/dv-img-fourNew.webp")}
                      alt="AI chatbot development company"
                      className="dev_ser_img"
                    />
                  </div>
                  <h6>API based extensibility</h6>
                </div>
              </div>
            </div>
          </div>

          <p className="ai_ch_subcontent ai_ch_dv_content">
            With mobile apps driving user engagement, having an AI-powered
            chatbot inside your application can make a major difference.
          </p>
        </article>

        {/* choose */}
        <article className="ai_choose ai_ch_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="ai_ch_subtitle text-center">
              Choosing <span className="ai_ch_span"> the Best Chatbot</span>{" "}
              Developers
            </h3>
            <p className="ai_ch_subcontent ai_ch_choose_content">
              Your success in chatbot deployment heavily depends on the team
              behind it. The best chatbot developers bring a combination of
              technical expertise, domain knowledge, and creative thinking.
            </p>

            <div className="ai_ch_choose_box">
              <h6 className="ai_ch_choose_bx_title">What to Look for</h6>

              <div className="ai_choose_card_wrap">
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-one.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>Proven experience in AI chatbot development services</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-two.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>Strong NLP and ML capabilities</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-three.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>UI/UX design expertise</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-four.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>Transparent communication and agile methodology</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-five.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>Post-launch support and upgrades</p>
                </div>
              </div>

              <h6 className="ai_ch_choose_bx_title ai_ch_mt_50">
                Questions to Ask
              </h6>

              <div className="ai_choose_card_wrap">
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-six.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>Can you show chatbot case studies?</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-six.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>What NLP frameworks do you specialize in?</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-six.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>How do you ensure chatbot security?</p>
                </div>
                <div className="ai_choose_card">
                  <span>
                    <img
                      src={require("../../../image/aichat/choose-img-six.webp")}
                      alt="AI chatbot development company"
                    />
                  </span>
                  <p>What’s your approach to multilingual bots?</p>
                </div>
              </div>
            </div>

            <p className="ai_ch_subcontent ai_ch_choose_content">
              Hiring the best chatbot developers means fewer bugs, better
              performance, and long-term success.
            </p>
          </div>
        </article>

        <div className="ai_ch_grad_outer">
          {/* add values */}
          <article className="primary__landing-content-container ai_ch_mb_100">
            <h3 className="ai_ch_subtitle ai_ch_ad_title">
              How an AI Chatbot{" "}
              <span className="ai_ch_span">
                {" "}
                Development Company Adds Value
              </span>{" "}
              to Different Business Functions
            </h3>
            <p className="ai_ch_subcontent text-center">
              Let’s take a closer look at how chatbot automation impacts various
              departments
            </p>

            <div className="row g-4 mx-0 ai_add_row">
              <div className="col-lg-3 col-sm-6">
                <div className="ai_add_card">
                  <img
                    src={require("../../../image/aichat/add-img-one.webp")}
                    alt="AI chatbot development company"
                  />

                  <h5>Sales</h5>

                  <ul>
                    <li>Qualify leads instantly</li>
                    <li>Schedule sales calls</li>
                    <li>Recommend products</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="ai_add_card">
                  <img
                    src={require("../../../image/aichat/add-img-two.webp")}
                    alt="AI chatbot development company"
                  />

                  <h5>Marketing </h5>

                  <ul>
                    <li>Run campaigns via chat</li>
                    <li>Gather customer feedback</li>
                    <li>Grow your email list</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="ai_add_card">
                  <img
                    src={require("../../../image/aichat/add-img-three.webp")}
                    alt="AI chatbot development company"
                  />

                  <h5>Support</h5>

                  <ul>
                    <li>Handle Tier 1 queries</li>
                    <li>Reduce ticket volume</li>
                    <li>Offer instant issue resolution</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="ai_add_card">
                  <img
                    src={require("../../../image/aichat/add-img-four.webp")}
                    alt="AI chatbot development company"
                  />

                  <h5>HR</h5>

                  <ul>
                    <li>Assist with employee onboarding</li>
                    <li>Answer HR policy questions</li>
                    <li>Schedule interviews</li>
                  </ul>
                </div>
              </div>
            </div>

            <p className="ai_ch_subcontent text-center ai_ch_ad_content">
              With advanced AI chatbot development services, you can create bots
              for specific business needs.
            </p>
          </article>

          {/* cost */}
          <article className="primary__landing-content-container ai_ch_mb_100">
            <h3 className="ai_ch_subtitle text-center">
              <span className="ai_ch_span">Cost to Build </span>
              AI Chatbot
            </h3>
            <p className="ai_ch_subcontent ai_cst_content">
              The cost of creating an AI chatbot can vary based on features,
              complexity, and integrations.
            </p>

            <div className="ai_ch_cost_box">
              <div className="ai_ch_cost_box_inner">
                <h6 className="ai_ch_choose_bx_title ai_ch_fz_28">
                  Estimated Cost Breakdown
                </h6>

                <div className="row g-4 g-xl-5 ai_ch_cost_row">
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="ai_cost_card_grad">
                      <div className="ai_cost_card_outer">
                        <div className="ai_cost_card_inner">
                          <h5>$4,000–$5,000</h5>
                          <p>Simple bot (FAQ-based)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="ai_cost_card_grad">
                      <div className="ai_cost_card_outer">
                        <div className="ai_cost_card_inner">
                          <h5>$5,000–$10,000</h5>
                          <p>AI-powered bot with NLP</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="ai_cost_card_grad">
                      <div className="ai_cost_card_outer">
                        <div className="ai_cost_card_inner">
                          <h5>$15,000–$50,000</h5>
                          <p>Enterprise solution with integrations</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="ai_ch_subcontent ai_cst_content">
                  A reliable AI chatbot development company can offer
                  transparent pricing and help you get maximum ROI.
                </p>
              </div>
            </div>
          </article>

          <div className="ai_ch_grad_two"></div>
        </div>

        {/* frameworks */}
        <article className="container-fluid container-md ai_ch_mb_100">
          <div className="ai_ch_key_ben">
            <h3 className="ai_ch_subtitle ai_ch_kb_title">
              AI Chatbot <span className="ai_ch_span">Frameworks </span>
              Used by Us
            </h3>

            <p className="ai_ch_subcontent text-center">
              We work with leading platforms to create intelligent AI chatbots
            </p>

            <div className="row ai_ch_kb_row">
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="ai_ch_kb_lft">
                  <div className="ai_kb_out kb_cd_one">
                    <div className="ai_kb_card ">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-one.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">Google Dialogflow</p>
                      </div>
                    </div>
                  </div>
                  <div className="ai_kb_out kb_cd_two">
                    <div className="ai_kb_card ">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-two.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">IBM Watson Assistant</p>
                      </div>
                    </div>
                  </div>
                  <div className="ai_kb_out kb_cd_three">
                    <div className="ai_kb_card">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-three.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">Microsoft Bot Framework</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-6 ai_kb_img_col">
                <div>
                  <img
                    src={require("../../../image/aichat/kb-center.webp")}
                    alt="AI chatbot development company"
                    className="kb_center_img"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                {" "}
                <div className="ai_ch_kb_lft">
                  <div className="ai_kb_out kb_cd_four">
                    <div className="ai_kb_card ">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-four.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">Rasa Open Source</p>
                      </div>
                    </div>
                  </div>
                  <div className="ai_kb_out kb_cd_five">
                    <div className="ai_kb_card ">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-five.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">Amazon Lex</p>
                      </div>
                    </div>
                  </div>
                  <div className="ai_kb_out kb_cd_six">
                    <div className="ai_kb_card ">
                      <div className="ai_kb_card_inner">
                        <span className="ai_kb_img_wrap">
                          <img
                            src={require("../../../image/aichat/frame-img-six.webp")}
                            alt="AI chatbot development company"
                          />
                        </span>
                        <p className="ai_kb_content">GPT-based Custom Models</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="ai_ch_subcontent  ai_ch_ft_ct">
              Each platform has its strengths, and as a best AI chatbot
              development company we will help you choose the right one.
            </p>
          </div>
        </article>

        <div className="ai_ch_grad_outer">
          {/* future */}
          <article className="primary__landing-content-container ai_ch_mb_100">
            <h3 className="ai_ch_subtitle text-center">
              Future of <span className="ai_ch_span">AI Chatbots Trends</span>{" "}
              to Watch
            </h3>
            <p className="ai_ch_subcontent ai_ch_future_content">
              As AI evolves, the chatbot landscape is changing fast. Here's what
              the future looks like
            </p>

            <div className="row mx-0 g-4 ai_ch_future_row">
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="ai_ch_future_card_outer">
                  <div className="ai_ch_future_card">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777292889/future-img-oneNew_oz56gj.webp"
                      alt="AI chatbot development company"
                    />

                    <h5>Voice Bots</h5>
                    <p>
                      With Google Assistant & Alexa becoming mainstream, voice
                      enabled bots are gaining momentum.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="ai_ch_future_card_outer">
                  <div className="ai_ch_future_card">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777292888/future-img-twoNew_eicxv9.webp"
                      alt="AI chatbot development company"
                    />

                    <h5>Emotion AI</h5>
                    <p>
                      Bots are now being trained to detect user emotions and
                      respond empathetically.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="ai_ch_future_card_outer">
                  <div className="ai_ch_future_card">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777292889/future-img-threeNew_l96ips.webp"
                      alt="AI chatbot development company"
                    />

                    <h5>Multimodal Chatbots</h5>
                    <p>
                      Combining text, voice, and visual elements for a richer
                      experience.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="ai_ch_future_card_outer">
                  <div className="ai_ch_future_card">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777292888/future-img-fourNew_hpjjga.webp"
                      alt="AI chatbot development company"
                    />

                    <h5>Hyper-Personalization</h5>
                    <p>
                      Using real-time data and behavior analysis to deliver
                      truly personalized conversations.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="ai_ch_subcontent ai_ch_future_content">
              Investing in a future-ready AI chatbot development company ensures
              you stay ahead of these trends.
            </p>
          </article>

          {/* why choose */}
          <article className="primary__landing-content-container ">
            <h3 className="ai_ch_subtitle ai_ch_why_title">
              <span className="ai_ch_span">
                Why Choose Beleaf Technologies{" "}
              </span>
              as Your AI Chatbot Development Company?
            </h3>
            <p className="ai_ch_subcontent ai_ch_why_content">
              We are a top-rated AI chatbot development company known for
              delivering custom, intelligent chatbot solutions across
              industries. Our mission is to help you automate, personalize, and
              scale your customer interactions.
            </p>

            <div className="row mx-0 g-4 ai_ch_why_row">
              <div className="col-lg-4">
                <div className="ai_ch_why_outer">
                  <div className="ai_ch_why_inner">
                    <span>
                      <img
                        src={require("../../../image/aichat/why-img-one.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    <p>50+ successful chatbot projects</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ai_ch_why_outer">
                  <div className="ai_ch_why_inner">
                    <span>
                      <img
                        src={require("../../../image/aichat/why-img-two.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    <p>Affordable packages with 24/7 support</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ai_ch_why_outer">
                  <div className="ai_ch_why_inner">
                    <span>
                      <img
                        src={require("../../../image/aichat/why-img-three.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    <p>Dedicated AI and NLP team</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ai_ch_why_outer">
                  <div className="ai_ch_why_inner">
                    <span>
                      <img
                        src={require("../../../image/aichat/why-img-four.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    <p>Experts in Dialog Flow, Rasa, IBM Watson, and GPT</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ai_ch_why_outer">
                  <div className="ai_ch_why_inner">
                    <span>
                      <img
                        src={require("../../../image/aichat/why-img-five.webp")}
                        alt="AI chatbot development company"
                      />
                    </span>
                    <p>End-to-end AI chatbot development services</p>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <div className="ai_ch_grad_three"></div>
        </div>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              AI chatbots are no longer just a tech trend, they are a business
              necessity. With the power to improve engagement, cut costs, and
              deliver instant support, a well-built chatbot can dramatically
              boost your brand value. Partnering with the right AI chatbot
              development company gives you access to the technology, expertise,
              and strategy needed to thrive in the digital era. Whether you're
              focused on creating an AI chatbot, need expert AI chatbot app
              development services, or want an enterprise AI chatbot development
              service, we’re here to help.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What industries do you serve with your chatbot
                          solutions?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          We build chatbots for industries like e-commerce,
                          healthcare, finance, education, and customer service.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can your chatbots handle multiple languages?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, we develop multilingual chatbots that can
                          communicate with users in their preferred language.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Are your chatbots powered by generative AI or
                          rule-based systems?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          We offer both—rule-based for simple tasks and
                          generative AI for advanced, human-like conversations.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Will I be able to update the chatbot content myself?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, we provide user-friendly dashboards that let you
                          manage and update chatbot content easily.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Do you offer analytics to track chatbot performance?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Absolutely! Our solutions include analytics dashboards
                          to monitor user interactions, engagement, and
                          effectiveness.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default AIChat;
